export default {"src":"/_next/static/media/cloudLightning_40.8a1ff9de.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};